import { createFileRoute } from '@tanstack/react-router'
import { BenefitsJourneyPage } from '@/features/benefits/BenefitsJourneyPage'

export const Route = createFileRoute('/_authenticated/benefits/overview')({
  component: BenefitsJourneyPage,
})
